import { render, staticRenderFns } from "./CompetitionFilterAllLayout.vue?vue&type=template&id=88059564&scoped=true"
import script from "./CompetitionFilterAllLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionFilterAllLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88059564",
  null
  
)

export default component.exports